import { useEffect, useState } from 'react';

import { fetchQuickInferenceFrameUrl } from '../../../helpers/api/quick-inference/quick-inference';

export function useFrameImage(
  inferenceId: string,
  frameNumber: number,
  refreshKey = 0,
  enabled = true
) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!enabled || !inferenceId) {
      setLoading(false);
      setFailed(false);
      setUrl(null);
      return;
    }

    let revoked: string | null = null;
    let cancelled = false;
    setLoading(true);
    setFailed(false);
    setUrl(null);

    fetchQuickInferenceFrameUrl(inferenceId, frameNumber)
      .then((objectUrl) => {
        if (cancelled) {
          URL.revokeObjectURL(objectUrl);
          return;
        }
        revoked = objectUrl;
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setFailed(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      if (revoked) {
        URL.revokeObjectURL(revoked);
      }
    };
  }, [inferenceId, frameNumber, refreshKey, enabled]);

  return { url, loading, failed };
}
